import React from "react";
import { Modal } from "@material-ui/core";
import moment from "moment";
import { SingleDatePicker } from 'react-dates';

import Button from "../Button";

import PushHistory from "../../utils/PushHistory";
import { getFormData } from "../../utils/SettingsRetriever";

import LocaleAsString from "../../LocaleEngine/LocaleAsString";

import "./index.scss";

export default class ActivitiesModal extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            phase: 1,
            modalConfig: this.props.config
        };
    }

    componentDidMount(){
        let form = getFormData().lodging;
        form.arrivalDate = moment.utc(form.arrivalDate);
        form.departureDate = moment.utc(form.departureDate);
        form.activitiesDate = form.arrivalDate.clone().add(1, 'day');

        this.setState({ form });
    }

    getLink = (section) => {
        if (section.indexOf("http") >= 0) {
            window.open(section, "_blank")
        } else {
            PushHistory(`${section}?startDate=${this.state.form.activitiesDate.format("YYYY-MM-DD")}`)
        }
    }

    getActivitiesModalContent = (phase) => {
        const { onCloseModal } = this.props;

        let modalContent = {};
        if (phase === 1){
            if (this.state.modalConfig){
                modalContent = this.state.modalConfig.config[`phase${phase}`]
            }
            return (
                <div className="activitiesModal">
                    <img alt={modalContent.title} src={modalContent.image} />
                    <div className="modalTitle">
                        {LocaleAsString(modalContent.title)}
                    </div>
                    <div className="modalSubTitle">
                        {LocaleAsString(modalContent.subtitle)}
                    </div>
                    <Button 
                        className="modalYes" 
                        onClick={
                            () => modalContent.section 
                            ? this.getLink(modalContent.section)
                            : this.setState({ phase: 2 })
                        }
                    >
                        {LocaleAsString(modalContent.yes)}
                    </Button>
                    <div onClick={() => onCloseModal()} className="modalNo">
                        {LocaleAsString(modalContent.no)}
                    </div>
                </div>
            )
        } else if (phase === 2){
            modalContent = this.state.modalConfig.config.phase2
            return (
                <div className="activitiesModal">
                    <img alt={modalContent.title} src={modalContent.image} />
                    <div className="modalTitle">
                        {LocaleAsString(modalContent.title)}
                    </div>
                    <div className="modalSubTitle">
                        {LocaleAsString(modalContent.subtitle)}
                    </div>
                    <SingleDatePicker
                        isOutsideRange={ (date) => {
                            if ( date.utc().isBefore(moment.utc(this.state.form.arrivalDate).startOf("day"))){
                                return true;
                            }
                            if ( date.isAfter(moment.utc(this.state.form.departureDate, "YYYY-MM-DD").endOf("day"))){
                                return true;
                            }
                            if ( date.isBefore(moment.utc().startOf('day')) ){
                                return true;
                            }
                        }}
                        hideKeyboardShortcutsPanel={true}
                        withFullScreenPortal={window.innerWidth < 991 ? true : false}
                        date={this.state.form.activitiesDate}
                        onDateChange={date => this.setState({ form: { ...this.state.form, activitiesDate: date } })}
                        focused={this.state.focused}
                        onFocusChange={({ focused }) => this.setState({ focused })}
                        id="your_unique_id"
                        // eslint-disable-next-line
                        numberOfMonths={1}
                        placeholder="Arrival Date"
                        readOnly={true}
                    />
                    <Button className="modalYes" onClick={ () => PushHistory(`${modalContent.search.section}?startDate=${this.state.form.activitiesDate.format("YYYY-MM-DD")}`)}>
                        {LocaleAsString(modalContent.search.text)}
                    </Button>
                    <div onClick={ () => onCloseModal()} className="modalNo">
                        {LocaleAsString(modalContent.no)}
                    </div>
                </div>
            )
        }
    }

    render(){
        const { getActivitiesModalContent, props, state } = this;
        const { phase } = state;
        const { open, container = null } = props;
        return (
            <Modal
                open={open}
                disablePortal={container ? false : true}
                container={container ? container : null}
            >
                <div className="outerModal">
                    {getActivitiesModalContent(phase)}
                </div>
            </Modal>
        )
    }
}